@if (visible()) {
  <div class="card">
    <div class="card-head">
      <div>All your scripts in one secure place.</div>
      <ion-icon class="close-icon" name="close" (click)="visible.set(false)" />
    </div>
    <div class="card-desc">Get the app today.</div>
    <div class="qr-wrapper">
      <qrcode qrdata="https://app.chemist2u.com.au/download" [width]="128" colorLight="#f4487500" [margin]="0" errorCorrectionLevel="Q"></qrcode>
      <div>Scan to download</div>
    </div>
  </div>
}